/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type risk_scenario_RiskFactor = {
    description?: string;
    name?: string;
    type?: risk_scenario_RiskFactor.type;
};

export namespace risk_scenario_RiskFactor {

    export enum type {
        SECTOR = 'sector',
        GEOGRAPHY = 'geography',
        CURRENCY = 'currency',
        INSTRUMENT_TYPE = 'instrument type',
        PRODUCT_LIST = 'product list',
        ASSET_CLASS = 'asset class',
        CATEGORY_GROUP = 'category group',
        CATEGORY_NAME = 'category name',
        TOP_HOLDINGS = 'top holdings',
    }


}

